import React from "react";
import PropTypes from "prop-types";

import {isMobile} from "../utils";


class TimeInput extends React.PureComponent {
    static propTypes = {
        id: PropTypes.string,
        name: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        className: PropTypes.string,
        placeholder: PropTypes.string,
    };

    static defaultProps = {
        className: 'form-input'
    };

    static isValidValue(string) {
        return /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(string);
    }

    isMobile = isMobile();

    render() {
        const {id, name, value, onChange, className, placeholder} = this.props;
        const type = this.isMobile ? "time" : "text";

        return <input type={type} id={id || name} className={className} name={name} value={value}
                      placeholder={placeholder} onChange={onChange} pattern="[0-9]{2}:[0-9]{2}"/>;
    }
}

export default TimeInput;